import { FC } from 'react';
import { Button } from '@components/common/Button';
import { FormattedMessage } from 'react-intl';
import { StudentLoan } from '@pages/ApplicationFormPage/StudentLoans/StudentLoan/StudentLoan';
import { useSearchParams } from 'react-router-dom';
import { useNavigateBack } from '@hooks/useNavigateBack';
import { ApplicationFormPageEnum } from '../types';
import { studentLoansQuestions } from './questions';
import { IStudentLoansProps } from './types';

export const StudentLoans: FC<IStudentLoansProps> = ({
  onAddStudentLoanRedirect,
  onEditStudentLoanRedirect,
  onRemoveStudentLoanById,
  studentLoans,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigateBack = useNavigateBack();

  const nextStepRedirectHandler = () => {
    searchParams.set('section', ApplicationFormPageEnum.ADDITIONAL_NOTES);
    setSearchParams(searchParams);
  };

  return (
    <>
      <div className={'mb-8 flex items-baseline justify-between'}>
        <FormattedMessage id={studentLoansQuestions.studentLoans.header} tagName={'p'} />
        <Button variant={'contained'} className={'ml-5 shrink-0'} onClick={onAddStudentLoanRedirect}>
          <FormattedMessage id={studentLoansQuestions.studentLoans.add} />
        </Button>
      </div>
      <div className={'w-full'}>
        {studentLoans.length === 0 ? (
          <p className={'rounded-sm border border-solid border-gray-300 py-16 text-center text-gray-400'}>
            <FormattedMessage id={studentLoansQuestions.studentLoans.empty} />
          </p>
        ) : (
          <div className={'grid grid-cols-4 gap-4'}>
            {studentLoans.map(loan => (
              <StudentLoan
                key={loan.id}
                onDelete={() => onRemoveStudentLoanById(loan.id)}
                onEdit={() => onEditStudentLoanRedirect(loan)}
                borrower={loan.borrower}
                monthlyPayment={String(loan.monthlyPayment)}
              />
            ))}
          </div>
        )}
      </div>
      <div className={'mt-8 flex justify-between'}>
        <Button variant={'outlined'} onClick={navigateBack}>
          <FormattedMessage id={'cta.back'} />
        </Button>

        <Button variant={'contained'} onClick={nextStepRedirectHandler}>
          <FormattedMessage id={'cta.continue'} />
        </Button>
      </div>
    </>
  );
};
